import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import OrderCollectionAutocomplete from '../../OrderCollectionAutocomplete';
import SettingContainer from '../../SettingContainer';
import { OrderCollectionSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const OrderCollectionSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
  orderSeparation,
}: OrderCollectionSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_COLLECTION)}
      description={LangEnum.GENERAL_SETTINGS_COLLECTION_DESCRIPTION}
    >
      {orderSeparation ? (
        <Stack sx={{ gap: 2 }}>
          <OrderCollectionAutocomplete
            label={translate(LangEnum.GENERAL_SETTINGS_PRE_ORDER_COLLECTION)}
            value={generalSettings.preOrderCollection || undefined}
            onChange={(collection) =>
              handleChangeAndBlur({ value: collection || null, name: 'preOrderCollection' })
            }
          />
          <OrderCollectionAutocomplete
            label={translate(LangEnum.GENERAL_SETTINGS_READY_FOR_DELIVERY_COLLECTION)}
            value={generalSettings.readyForDeliveryCollection || undefined}
            onChange={(collection) =>
              handleChangeAndBlur({ value: collection || null, name: 'readyForDeliveryCollection' })
            }
          />
        </Stack>
      ) : (
        <OrderCollectionAutocomplete
          value={generalSettings.orderCollection || undefined}
          onChange={(collection) =>
            handleChangeAndBlur({ value: collection || null, name: 'orderCollection' })
          }
        />
      )}
    </SettingContainer>
  );
};

export default OrderCollectionSectionGeneralSettings;
